import type { Conversation } from "./types";

export function isGuestSideExternalConversation(conversation: Conversation): boolean {
  return Boolean(
    conversation.is_cross_account &&
    conversation.my_membership &&
    conversation.my_membership.account_id !== conversation.account_id,
  );
}

export function getConversationDisplayTitle(
  conversation: Conversation,
  fallbackTitle: string,
  externalServiceTitle: string,
): string {
  if (isGuestSideExternalConversation(conversation)) {
    if (conversation.external_title) {
      return conversation.external_title;
    }
    if (conversation.account_name) {
      return externalServiceTitle.replace("{account}", conversation.account_name);
    }
  }
  return conversation.title || fallbackTitle;
}
